import { configureStore } from "@reduxjs/toolkit";
import addressReducer from "./slices/address.slice";
import qsoReducer from "./slices/qso.slice";
import logReducer from "./slices/log.slice";
import uiReducer from "./slices/ui.slice";

export const store = configureStore({
  reducer: {
    addresses: addressReducer,
    qsos: qsoReducer,
    logs: logReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
